import { Link, useNavigate, useParams } from 'react-router-dom'
import { api, useMe, useRefreshMe, useSelectPartner } from '../../lib'
import { Err, useAction } from './common'

export function InviteAcceptPage() {
  const { token } = useParams()
  const { me } = useMe()
  const nav = useNavigate()
  const refresh = useRefreshMe()
  const select = useSelectPartner()
  const a = useAction(
    () => api<{ partner_id: string }>('POST', `/api/partner-invites/${token}/accept`),
    async (r) => {
      select(r.partner_id)
      await refresh()
      nav('/partner')
    },
  )
  if (!me?.user) {
    return (
      <div className="page narrow">
        <p>
          <Link to={`/login?next=/partner-invite/${token}`}>Sign in</Link> with the invited email to join the partner team.
        </p>
      </div>
    )
  }
  return (
    <div className="page narrow stack">
      <h1>Join a partner team</h1>
      <p>You are signed in as {me.user.email}.</p>
      <Err error={a.error} />
      <button className="primary" data-testid="partners-invite-accept" disabled={a.busy} onClick={() => a.run(undefined)}>
        Accept invite
      </button>
    </div>
  )
}
